import { FC } from 'react'

import { Field, SelectDropdown, Slider } from '@makyoapp/makyo-ui'

import { BuilderComponentSetting } from '@/shared/builder'
import { SectionBackgroundGroupProps } from '@/shared/builder/default/section.default'
import { validSliderValue } from '@/shared/utils'
import { BrandKitColorsDropdown } from '@/components/BrandKitColorsDropdown'

interface PatternBackgroundSelectProps {
  layer: SectionBackgroundGroupProps
  handleUpdate: (id: number, newValues: any) => Promise<void>
  colorVariantSettings: BuilderComponentSetting['colorVariantSettings']
  compSettings: Record<string, any>
}

export const PatternBackgroundSelect: FC<PatternBackgroundSelectProps> = ({
  handleUpdate,
  layer,
  colorVariantSettings,
  compSettings,
}) => {
  const options = [
    'No Pattern',
    'Circle1',
    'Circle2',
    'Circle3',
    'Circle4',
    'Circle5',
    'Circle6',
    'Circle7',
    'Circle8',
    'Circle9',
    'Circle10',
    'Circle11',
    'Circle12',
    'Cross1',
    'Cross2',
    'Cross3',
    'Cross4',
    'Diagonal1',
    'Diagonal2',
    'Diagonal3',
    'Diagonal4',
    'Diagonal5',
    'Diamond1',
    'Diamond2',
    'Diamond3',
    'Diamond4',
    'Diamond5',
    'Diamond6',
    'Diamond7',
    'Diamond8',
    'Diamond9',
    'Dot1',
    'Dot2',
    'Dot3',
    'Dot4',
    'Line1',
    'Line2',
    'Line3',
    'Line4',
    'Line5',
    'Line6',
    'Line7',
    'Line8',
    'Line9',
    'Line10',
    'Mixed1',
    'Mixed2',
    'Mixed3',
    'Mixed4',
    'Mixed5',
    'Mixed6',
    'Mixed7',
    'Mixed8',
    'Mixed9',
    'Mixed10',
    'Mixed11',
    'Mixed12',
    'Mixed13',
    'Mixed14',
    'Stripe1',
    'Stripe2',
    'Stripe3',
    'Stripe4',
    'Stripe5',
    'Stripe6',
    'Symbol1',
    'Symbol2',
    'Triangle1',
    'Triangle2',
    'Triangle3',
    'Triangle4',
    'Triangle5',
    'Triangle6',
    'Triangle7',
    'Wave',
    'Zigzag',
  ]

  const opacity = layer.values.opacity ?? 0.1
  const size = layer.values.size ?? 16

  return (
    <div className='space-y-4'>
      <SelectDropdown
        onChange={(e) => handleUpdate(layer.id, { type: e })}
        options={options}
        withSearch
        value={layer.values.type}
      />
      {layer.values.type && (
        <>
          <Field isVertical>
            <span className='text-left'>Color</span>
            <BrandKitColorsDropdown
              id={layer.id.toString()}
              value={(layer.values.color as string) ?? 'primary-10'}
              onChange={(e) => handleUpdate(layer.id, { color: e })}
              showExtendedColors
            />
          </Field>
          <Field isVertical>
            <span className='text-left'>Opacity</span>
            <Slider
              min={0}
              max={1}
              step={0.05}
              values={[validSliderValue(opacity as number, 0, 1)[0]]}
              onChange={(e) => handleUpdate(layer.id, { opacity: e })}
              showLabel
            />
          </Field>
          <Field isVertical>
            <span className='text-left'>Size</span>
            <Slider
              min={16}
              max={96}
              step={4}
              values={[validSliderValue(size as number, 16, 96)[0]]}
              onChange={(e) => handleUpdate(layer.id, { size: e })}
              showLabel
            />
          </Field>
        </>
      )}
    </div>
  )
}
